import React from "react";

const ServiceDetailsRight = ({ service }) => {
  return (
    <section className="max-lg:w-[70%] w-full px-5 max-sm:px-20 flex content-start  relative flex-col max-lg:px-0">
      <div className="flex content-start  relative flex-col">
        <div>
          <img src={service?.banner} alt="Global IT Master" />
        </div>
        <h2 className="my-[18px] text-[#000001] text-[34px] font-fira font-bold">
          {service.title}
        </h2>
        <p className="mb-[18px] text-[#888] text-[17px] leading-[29px]">
          <b className="text-[#000001] -"> {service?.description?.content1}</b>
          <div className="ml-5 py-5">
            {
              <ol className="list-decimal">
                {service?.description?.items.map((item, i) => (
                  <li key={i}>{item}</li>
                ))}
              </ol>
            }
          </div>
          <b className="text-[#000001] "> {service?.description?.content2}</b>
        </p>
        <div className="flex flex-col max-lg:flex-row justify-between items-center gap-5">
          <div className="w-full">
            <div className="bg-[#000917] py-8 max-sm:px-[40px] px-3 flex items-center">
              <div className="mr-[24px]">
                <i
                  style={{
                    backgroundImage:
                      "linear-gradient(to left, #08B6FF, #0B5ADB)",
                  }}
                  className="fa-solid fa-award text-[44px] text-linear-gradient"
                ></i>
              </div>
              <div>
                <h4 className="text-[22px] text-[#fff] mb-[10px] font-fira font-bold">
                  Why It soft?
                </h4>
                <p className="text-[#ABABAB] text-base w-[200px]">
                  We're making room for self care today with plan.
                </p>
              </div>
            </div>
          </div>
          <div className=" w-full">
            <div className="bg-[#000917] py-8 max-sm:px-[40px] px-3 flex items-center">
              <div className="mr-[24px]">
                <i
                  style={{
                    backgroundImage:
                      "linear-gradient(to left, #08B6FF, #0B5ADB)",
                  }}
                  className="fa-solid fa-comments text-[44px] text-linear-gradient"
                ></i>
              </div>
              <div>
                <h4 className="text-[22px] text-[#fff] mb-[10px] font-fira font-bold">
                  Unlimited support
                </h4>
                <p className="text-[#ABABAB] text-base w-[200px]">
                  New range coming in on a weekly basis veg section.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceDetailsRight;
